import { Accordion, AccordionDetails, AccordionSummary, CircularProgress, Typography, Snackbar, Alert } from "@mui/material"
import Schema from "./schemaList-components/Schema"
import { useEffect, useState } from "react"
import ExpandMore from "@mui/icons-material/ExpandMore"
import KwilDB from "kwildb"
import { useSelector } from "react-redux"
import CreateSchemaButton from "./schemaList-components/CreateSchemaButton"
import NewSchemaCreation from "./schemaList-components/NewSchemaCreation"

export default function SchemaList({initialTable, initialSchema, privKey, secret, update, setUpdate}) {
    const [schemaLoader, setSchemaLoader] = useState(false)
    const [noFunds, setNoFunds] = useState(false)
    const [mouseEnter, setMouseEnter] = useState(false)
    const [schemas, setSchemas] = useState([])
    const [addingSchema, setAddingSchema] = useState(false)
    const [loadAddingSchema, setLoadAddingSchema] = useState(false)
    const [newSchema, setNewSchema] = useState("")
    const [error, setError] = useState("")
    const [success, setSuccess] = useState("")
    const loadedMoat = useSelector((state) => state.loadedMoat.value)
    

    useEffect(() => {
        setSchemaLoader(true);
        setTimeout(async function () {
          const kwilDB = KwilDB.createConnector(
            {
              host: "test-db.kwil.xyz",
              protocol: "https",
              port: null,
              moat: loadedMoat,
              privateKey: JSON.parse(privKey),
            },
            secret
          );
      
          let temp = (
            await kwilDB.query(
              `SELECT schema_name FROM information_schema.schemata EXCEPT SELECT schema_name FROM information_schema.schemata WHERE schema_name LIKE 'pg_toast%' OR schema_name LIKE 'pg_temp%' OR schema_name = 'pg_catalog' OR schema_name = 'information_schema';`
            )
          ).rows;
    
          if (temp) {
            setNoFunds(false)
            setSchemaLoader(false)
            setSchemas(temp)
            
          } else {
            setSchemaLoader(false)
            setSchemas([])
            setNoFunds(true)
          }
        })
      }, [privKey, update])
    
    function createSchema(e) {
      e.preventDefault()
      setLoadAddingSchema(true)
      setTimeout(async function () {
        const kwilDB = KwilDB.createConnector(
          {
            host: "test-db.kwil.xyz",
            protocol: "https",
            port: null,
            moat: loadedMoat,
            privateKey: JSON.parse(privKey)
          },
          secret
        )
        await kwilDB.query(`CREATE SCHEMA if NOT EXISTS ${newSchema}`, true)
        setAddingSchema(false)
        setLoadAddingSchema(false)
        setUpdate(update + 1)
        window.location.reload(true)
      })
    }

    return(
      <>
        <div className="schema-list">
            <CircularProgress
                sx={{
                    display: schemaLoader && privKey !== "" ? "flex" : "none",
                    margin: "auto",
                    color: "#linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)"
                }}
            />
           <div
                style={{
                    display: schemaLoader ? "none" : "flex",
                    flexDirection: "column",
                    flex: 1,
                }}
            >
                {noFunds && <p className="nofunds-message">Please add funds to a funding pool to get started!</p>}
                <Accordion
                    defaultExpanded={initialTable.current} // have to add .current??
                    disableGutters
                    sx={{
                        width: "100%",
                        backgroundColor: "transparent",
                        boxShadow: "none"
                    }}
                >
                    <AccordionSummary
                        sx={{
                            "& .MuiAccordionSummary-content": { margin: 0 },
                            "&.MuiAccordionSummary-root": {
                              maxHeight: "38px",
                              minHeight: "38px",
                              padding: "0 8px",
                            },
                          }}
                        expandIcon={<ExpandMore sx={{ color: mouseEnter ? "#118EA0" : "#fff" }}/>}
                        onMouseEnter={() => setMouseEnter(true)}
                        onMouseLeave={() => setMouseEnter(false)}
                    >
                        <Typography sx={{ color: mouseEnter ? "#118EA0" : "#fff", fontWeight: "bold", fontFamily: "Averta"}}>
                          Schemas
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            "&.MuiAccordionDetails-root": {
                            padding: "0px 8px",
                            },
                        }}
                    >
                        {schemas.map((schema, index) => {
                            return(
                                <Schema
                                    privKey={privKey}
                                    secret={secret}
                                    loadedMoat={loadedMoat}
                                    name={schema.schema_name}
                                    initialSchema={initialSchema}
                                    key={index}
                                    setError={setError}
                                    setSuccess={setSuccess}
                                />
                            )
                        })}
                        
                    </AccordionDetails>
                </Accordion>
                <CreateSchemaButton 
                          schemaLoader={schemaLoader}
                          setAddingSchema={setAddingSchema}
                          noFunds={noFunds}
                          setError={setError}
                        />
                <NewSchemaCreation
                  loadAddingSchema={loadAddingSchema}
                  schemaLoader={schemaLoader}
                  addingSchema={addingSchema}
                  setNewSchema={setNewSchema}
                  newSchema={newSchema}
                  setAddingSchema={setAddingSchema}
                  createSchema={createSchema}
                  setError={setError}
                />
            </div>
        </div>
        <Snackbar
            sx={{ margin: "0px auto" }}
            open={error}
            autoHideDuration={4000}
            onClose={() => setError("")}
        >
            <Alert
                variant="filled"
                severity="error"
                sx={{ width: "100%" }}
                onClose={() => setError("")}
            >
                {error}
            </Alert>
        </Snackbar>
        <Snackbar
            sx={{ margin: "0px auto" }}
            open={success}
            autoHideDuration={4000}
            onClose={() => setSuccess("")}
        >
            <Alert
                variant="filled"
                severity="error"
                sx={{ width: "100%" }}
                onClose={() => setSuccess("")}
            >
                {success}
            </Alert>
        </Snackbar>
      </>
    )
}